<p-toast></p-toast>

<div *ngIf="(!this.loading)">
    <div class="ui-g-12">
        <div style="display: flex;align-items: center;justify-content: end;margin-top: 10px;">
            <div style="font-size: 17px;font-weight: bold;">
                <p>Choose Language : </p>
            </div>
            <select class="notranslate customize-dropdown" [(ngModel)]="selectedLanguage"
                (change)="translatePage($event)">
                <option *ngFor="let option of languageOptions" [value]="option.code">
                    {{ option.name }}
                </option>
            </select>
        </div>
    </div>
    <div class="ui-g-12">
        <div class="ui-g-3" style="display: table; height: 200px; overflow: hidden;">
            <div style="display: table-cell; vertical-align: middle; text-align:center;">
                <img [src]="this.doctorICard?.avatar_url==null || (this.doctorICard?.avatar_url!=null && this.doctorICard?.avatar_url.length==0)?'./assets/images/default_profile.jpg':this.doctorICard?.avatar_url"
                    height='150' width="150" style="border-radius: 50%; ;">
            </div>
        </div>
        <div class="ui-g-3" style="display: table; height: 200px; overflow: hidden;">
            <div style="display: table-cell; vertical-align: middle; text-align:center;" class="notranslate">
                {{this.doctorICard?.first_name+" "+this.doctorICard?.last_name |
                titlecase}}
            </div>
        </div>
        <div class="ui-g-3" style="display: table; height: 200px; overflow: hidden;">
            <div style="display: table-cell; vertical-align: middle; text-align:center;">
                <p-button [disabled]="this.posting" (click)="editProfile()" icon="pi pi-external-link"
                    label="Edit Profile"></p-button>
            </div>
        </div>
        <div class="ui-g-3" style="display: table; height: 200px; overflow: hidden;" *ngIf="this.is_doctor">
            <div style="display: table-cell; vertical-align: middle; text-align:center;">
                <p-button [disabled]="this.posting" (click)="showcardDialog()" icon="pi pi-external-link"
                    label="ID Card"></p-button>
            </div>
        </div>

        <p-dialog [(visible)]="displaycard" [contentStyle]="{height:'390px'}" [style]="{width: '45vw'}"
            (onHide)="close()" header="eGlobalDoctors ID Card" [baseZIndex]="10000">
            <div class="ui-g"
                style="background-color: #93bff9;border-top-right-radius:30px;border-top-left-radius: 30px;">
                <div class="ui-g-5"></div>
                <div class="ui-g-2" style="align-content: center;text-align: center;">
                    <img src="assets/images/logo2.png" alt="" height="90" />
                </div>

                <div class="ui-g-5"></div>
            </div>


            <div class="ui-g-12"
                style="background-color: #ECECEC;border-bottom-left-radius: 30px;border-bottom-right-radius: 30px;"
                *ngIf="this.doctorICard">
                <div class="ui-g-12">
                    <div class="ui-g-6">
                        <label for="Mrn"><b>Consultant ID</b></label><br>
                        <div class="id_card_data">
                            {{this.doctorICard.country?.acronym+" "+this.doctorICard.doctor_profile?.doctor_number}}
                        </div><br>
                        <label for="vtill"><b>Speciality</b></label><br>
                        <div class="id_card_data">{{this.doctorICard.doctor_profile?.speciality.specialty_name}}</div>
                        <br>
                        <!-- <label for="dob"><b>Date of birth</b></label><br>
                        <div class="id_card_data">{{id_card.dateOfBirth}}</div> -->




                    </div>
                    <div class="ui-g-6">
                        <img [src]="this.doctorICard?.avatar_url==null || (this.doctorICard?.avatar_url!=null && this.doctorICard?.avatar_url.length==0)?'./assets/images/default_profile.jpg':this.doctorICard?.avatar_url"
                            style="border-radius: 25%;margin-right:auto;margin-left:auto;" height='110' width='110'><br>
                        <label for="name"><b>Name</b></label><br>
                        <div class="id_card_data notranslate">
                            {{this.doctorICard?.first_name+" "+this.doctorICard?.middle_name+"
                            "+this.doctorICard?.last_name | titlecase}}
                        </div>



                    </div>
                    <div class="ui-g-12" style="text-align: center;" *ngIf="!is_uk_country">
                        <a href="#" onclick="return false;">eGlobalDoctors.com</a>
                    </div>
                     <div class="ui-g-12" style="text-align: center;" *ngIf="is_uk_country">
                        <a href="#" onclick="return false;">eGlobalDoctors.co.uk</a>
                    </div>
                </div>
            </div>
            <p-footer>
                <button pButton type="button" class="ui-button-warning" label="Cancel" icon="pi pi-times"
                    [disabled]="this.posting" (click)="close()"></button>
            </p-footer>
        </p-dialog>


    </div>





    <!-- <section class="ftco-section" id="workflow-section"> -->
    <!-- </section>
     -->
    <div *ngIf="this.my_patients.length>0">
        <div class="ui-g-12" style="text-align: center;">
            <div>
                <h2>Upcoming Appointments</h2>
            </div>
        </div>
        <div class="upcoming-appt-fix" style="margin:1%;">
            <div class="row">
                <div class="ui-g-5 card-box" *ngFor="let patient of this.my_patients ">
                    <div class="ui-g-8 center-align">
                        <div class="ui-g-12">
                            <img [src]="patient?.patientUrl==null || (patient?.patientUrl!=null && patient?.patientUrl.length==0)?'./assets/images/test_profile.png':patient?.patientUrl"
                                style="border-radius: 50%;width: 100px;height:100px;" alt="">
                        </div>
                        <div class="ui-g-12 notranslate">
                            {{patient?.patientName}}<br>
                            {{patient?.consultation_date | date:'medium'}}
                        </div>
                    </div>

                    <div class="ui-g-4 vl center-align">
                        <button pButton label="Share" type="button " class="btn btn-primary btn-sm btn-space"
                            [disabled]="this.share_loader"
                            (click)="open_share(patient.consultation_id,patient.patient_guid);">
                            <!-- Intiate -->
                        </button>

                        <p>{{patient?.status}}</p>

                        <button pButton type="button" class="btn btn-primary btn-sm btn-space"
                            (click)="open_initate(patient?.current_user_guid , patient?.patient_guid , patient?.consultation_id , patient?.status)"
                            [disabled]="this.initateLoader" label="Initiate"></button>

                    </div>

                </div>
                <div class="row ui-g-12 container justify-content-center text-center alert alert-danger"
                    *ngIf="initate_response?.success!=null && initate_response?.success==false">
                    <p *ngIf="initate_response?.error!=null">{{initate_response?.error?.message}}</p>
                    <div *ngIf="initate_serverError?.error!=null && initate_serverError?.statusCode!=500">
                        <p *ngFor="let message of initate_serverError?.message">{{message}}</p>
                    </div>
                    <div *ngIf="initate_serverError?.error!=null && initate_serverError?.statusCode==500">
                        <p>{{initate_serverError?.message}}</p>
                    </div>

                </div>

            </div>
        </div>

        <p-dialog header="Share Communication Link" [contentStyle]="{'height':'500px'}" [style]="{'width':'80vw'}"
            (onHide)="closeShareDialog()" [resizable]="true" [responsive]="true" [(visible)]="this.share_dialog">

            <app-share-message-doctors *ngIf="this.share_dialog" [messageString]="this.message"
                (onGetLink)="getToken($event)" (dialogChange)="closeShare($event)"></app-share-message-doctors>
            <div class="row container justify-content-center text-center alert alert-danger"
                *ngIf="response.success!=null && response.success==false">
                <p *ngIf="response.error!=null">{{response.error.message}}</p>
                <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
                    <p *ngFor="let message of serverError?.message">{{message}}</p>
                </div>
                <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
                    <p>{{serverError?.message}}</p>
                </div>
            </div>
        </p-dialog>

        <div class="row container justify-content-center text-center alert alert-danger"
            *ngIf="response?.success!=null && response?.success==false">
            <p *ngIf="response?.error!=null">{{response?.error?.message}}</p>
            <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
                <p *ngFor="let message of serverError?.message">{{message}}</p>
            </div>
            <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
                <p>{{serverError?.message}}</p>
            </div>

        </div>
    </div>
    <ng-container *ngIf="!this.loading1">
        <div class="ui-g-12" *ngIf="this.is_superadmin && !this.is_primary_provider ">
            <div class="ui-g-12">
                <div class="ui-g">
                    <div class="card two-d-card mr-auto ml-auto mt-5 ui-g-12" style="padding: 10px">
                        <div class="card-body heading4">
                            <div class="ui-g-12" style="display: flex; flex-wrap: wrap;">
                                <div class="ui-g-12 ui-lg-2" style="margin-top:20px;">
                                    <p class="status_heading">
                                        <b>Subscription Status: </b>
                                    </p>
                                </div>
                                <div class="ui-g-12 ui-lg-6" *ngIf="this.providerLicensesData.length > 0; else noplans">
                                    <span *ngFor="let license of providerLicensesData">

                                        <div class="ui-g-12 ui-lg-6 mb-2">
                                            <p class="heading3 egd-color">
                                                {{ license.license.name }} Plan Subscribed.
                                            </p>
                                            <div>
                                                Valid Till {{ license.expiry_date | date: 'mediumDate' }}
                                            </div>
                                        </div>
                                        <div class="ui-g-12 ui-lg-6 mb-2">
                                            <button pButton type="button" label="Upgrade plan" style="margin-top: 30px;"
                                                icon="pi pi-external-link" [disabled]="this.posting"
                                                (click)="gotoPlans()" class="btn btn-primary card-buttons"></button>
                                        </div>


                                    </span>
                                </div>
                                <div class="ui-g-12 ui-lg-4" style="margin-top:20px;"
                                    *ngIf="this.providerLicensesData.length > 0">
                                    <p class="status_heading">
                                        <b>User Limit: </b><br>
                                        <span style="color: green;">Doctors/Admins/Superadmins: {{this.dcount}} of
                                            {{this.total_number_of_doctors}}</span><br>
                                        <span style="color: green;">Patients: {{this.ucount}} of
                                            {{this.total_number_of_users}}</span>
                                    </p>
                                </div>

                            </div>


                            <div class="ui-g-12" style="display: flex; flex-wrap: wrap; margin-top: 20px;"
                                *ngIf="this.providerLicensesData.length > 0">
                                <div class="ui-g-12 ui-lg-2">
                                    <p class="status_heading"
                                        *ngIf="!checklistData.hasDoctors || !checklistData.stripeKeys || !checklistData.hasLogo ||!checklistData.hasSpecialty || !checklistData.hasCountry">
                                        <b style="color:orange">Pending Checklist: </b>
                                    </p>
                                </div>
                                <div class="ui-g-12 ui-lg-10" style="margin-top: 7px;">
                                    <div class="ui-g-12 ui-lg-2 mb-2" *ngIf="!checklistData.hasCountry">
                                        <button pButton type="button" label="Update Countries"
                                            class="btn btn-primary card-buttons" style="width:157px"
                                            (click)="gotoCountry()"></button>
                                    </div>
                                    <div class="ui-g-12 ui-lg-2 mb-2" *ngIf="!checklistData.hasSpecialty">
                                        <button pButton type="button" label="Add Specialties"
                                            class="btn btn-primary card-buttons" style="width:140px"
                                            (click)="gotoSpeciality()"></button>
                                    </div>
                                    <div class="ui-g-12 ui-lg-2 mb-2" *ngIf="!checklistData.stripeKeys">
                                        <button pButton type="button" label="Link Stripe"
                                            class="btn btn-primary card-buttons" (click)="gotoStripe()"></button>
                                    </div>
                                    <div class="ui-g-12 ui-lg-2 mb-2" *ngIf="!checklistData.hasDoctors">
                                        <button pButton type="button" label="Add Doctors"
                                            class="btn btn-primary card-buttons" (click)="gotoDreg()"></button>
                                    </div>
                                    <div class="ui-g-12 ui-lg-2 mb-2" *ngIf="!checklistData.hasLogo">
                                        <button pButton type="button" label="Update Logo"
                                            class="btn btn-primary card-buttons" (click)="gotoLogo()"></button>
                                    </div>
                                </div>
                            </div>

                            <div class="justify-content:center" *ngIf="this.providerLicensesData.length > 0">
                                <p><span style="color:red;">Note*</span>: To cancel the subscribed plan before free
                                    trial ends please contact <a class="egd-color"
                                        href="mailto:support@eglobaldoctors.com">support@eglobaldoctors.com</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ng-template #noplans>
            <p style="margin-right: 10px;margin-top:50px;">No Plan Subscribed , <span
                    *ngIf="!this.has_trial_completed">Click on Explore more to start your 7 days free trial.</span></p>
            <button pButton type="button" class="card-buttons" label="Explore Plans"
                style="height: 40%;margin-top:50px;" icon="pi pi-external-link" [disabled]="this.posting"
                (click)="gotoPlans()"></button>
        </ng-template>

    </ng-container>

</div>

<div *ngIf="this.loading || this.loading1">
    <h4>Loading</h4>
    <p-progressSpinner [style]="{width: '50px', height: '50px'}" *ngIf="this.loading || this.loading1" strokeWidth="6">
    </p-progressSpinner>
</div>